export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'yes'
    },
    setting: {
        logic: []
    },
    options: {
        yes: 'Yes',
        no: 'No'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Has Played',
        category: ['User', 'Plays'],
        description: 'Whether the user has played the game or not.',
        summarise: {
            template: {
                yes: 'User has played the game',
                no: 'User has not played the game'
            }
        }
    }
}